@if (!!pushWithLayout) {
  <article>
    <wc-wrapper
      [id]="uniqueId"
      [contentWrapper]="wrapper"
      [marginSize]="size === pushSizeEnum.l ? marginEnum.default_margin : sdLibConfig.get(brandCorner).componentMargin"
    >
      <sd-push-card #pushCardComponent
                    sd-component-wrapper-component
                    (click)="onPromoClick()"
                    [pushSize]="size"
                    [sdSpyTarget]="componentUid"
                    [push]="pushWithLayout.push"
                    [imageRatio]="pushWithLayout.imageRatio"
                    [textConfig]="pushWithLayout.textConfig"
                    [mediaConfig]="pushWithLayout.mediaConfig"
                    [mediaAsBackground]="pushWithLayout.mediaAsBackground"
                    [themesConfig]="pushWithLayout.themesConfig"
                    [titleLevel]="pushWithLayout.titleLevel"
                    (clicked)="onPushCardClicked($event)"
                    (videoEnded)="onVideoEndedClicked($event)"
                    (videoPlayed)="onVideoPlayedClicked($event)"
                    [twicPicsAutoSize]="!isFirst"
                    [isDescription]="pushWithLayout.isDescription"
                    [isFit]="pushWithLayout.isFit"
                    [hasModal]="pushWithLayout.hasModal"
                    [isLoading]="!isLoaded"
                    [brand]="brandCorner"
                    [brandBar]="pushWithLayout.brandBar"
      />
    </wc-wrapper>
  </article>
}
